/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: -jwsXBtJBhEb

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Header from "../../Header"; // plasmic-import: 4ClPPEaVaNLI/component
import ServiceMessage from "../../ServiceMessage"; // plasmic-import: OnWTFNPo14Tf/component
import HomeLoginSection from "../../HomeLoginSection"; // plasmic-import: vzgTyjXsvFqD/component
import HomeTopSection from "../../HomeTopSection"; // plasmic-import: irBak36DUa2B/component
import HomeSolutionsSection from "../../HomeSolutionsSection"; // plasmic-import: cEQHMEdyXB7i/component
import HomeProductsSection from "../../HomeProductsSection"; // plasmic-import: XTAvGJPchvtf/component
import HomeCaseStudiesSection from "../../HomeCaseStudiesSection"; // plasmic-import: rvlEtCxpePtd/component
import HomeBenefitsSection from "../../HomeBenefitsSection"; // plasmic-import: UptbiEIDaA4H/component
import CalloutSection from "../../CalloutSection"; // plasmic-import: hGcTP4LoXXzT/component
import Footer from "../../Footer"; // plasmic-import: AN9sHMOzPG9-/component
import ContactModal from "../../ContactModal"; // plasmic-import: 2lCEPY1ezZ3j/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicHome.module.css"; // plasmic-import: -jwsXBtJBhEb/css

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title:
      "MyEvaluations | The Human Approach in Medical Education Management™",
    description:
      "Leading solutions for GME, PA, and Nursing education management. Enhance your program now.",
    openGraph: {
      title:
        "MyEvaluations | The Human Approach in Medical Education Management™",
      description:
        "Leading solutions for GME, PA, and Nursing education management. Enhance your program now."
    },
    twitter: {
      card: "summary" as const,
      title:
        "MyEvaluations | The Human Approach in Medical Education Management™",
      description:
        "Leading solutions for GME, PA, and Nursing education management. Enhance your program now."
    },
    alternates: { canonical: "https://www.myevaluations.com/" }
  };
}

createPlasmicElementProxy;

export type PlasmicHome__VariantMembers = {};
export type PlasmicHome__VariantsArgs = {};
type VariantPropType = keyof PlasmicHome__VariantsArgs;
export const PlasmicHome__VariantProps = new Array<VariantPropType>();

export type PlasmicHome__ArgsType = {};
type ArgPropType = keyof PlasmicHome__ArgsType;
export const PlasmicHome__ArgProps = new Array<ArgPropType>();

export type PlasmicHome__OverridesType = {
  root?: Flex__<"div">;
  header?: Flex__<typeof Header>;
  serviceMessage?: Flex__<typeof ServiceMessage>;
  homeLoginSection?: Flex__<typeof HomeLoginSection>;
  homeTopSection?: Flex__<typeof HomeTopSection>;
  homeSolutionsSection?: Flex__<typeof HomeSolutionsSection>;
  homeProductsSection?: Flex__<typeof HomeProductsSection>;
  homeCaseStudiesSection?: Flex__<typeof HomeCaseStudiesSection>;
  homeBenefitsSection?: Flex__<typeof HomeBenefitsSection>;
  calloutSection?: Flex__<typeof CalloutSection>;
  footer?: Flex__<typeof Footer>;
  contactModal?: Flex__<typeof ContactModal>;
};

export interface DefaultHomeProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHome__RenderFunc(props: {
  variants: PlasmicHome__VariantsArgs;
  args: PlasmicHome__ArgsType;
  overrides: PlasmicHome__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "contactModal.open",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
        <meta
          key="description"
          property="description"
          content={pageMetadata.description}
        />
        <meta
          key="og:description"
          property="og:description"
          content={pageMetadata.description}
        />
        <meta
          key="twitter:description"
          property="twitter:description"
          content={pageMetadata.description}
        />

        <link rel="canonical" href={pageMetadata.alternates?.canonical} />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.root
          )}
        >
          <Header
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames("__wab_instance", sty.header)}
            currentPage={(() => {
              try {
                return $ctx.pagePath;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return undefined;
                }
                throw e;
              }
            })()}
            onContactClick={async () => {
              const $steps = {};

              $steps["updateContactModalOpen"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["contactModal", "open"]
                      },
                      operation: 0,
                      value: true
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateContactModalOpen"] != null &&
                typeof $steps["updateContactModalOpen"] === "object" &&
                typeof $steps["updateContactModalOpen"].then === "function"
              ) {
                $steps["updateContactModalOpen"] =
                  await $steps["updateContactModalOpen"];
              }
            }}
          />

          <ServiceMessage
            data-plasmic-name={"serviceMessage"}
            data-plasmic-override={overrides.serviceMessage}
            className={classNames("__wab_instance", sty.serviceMessage)}
          />

          {(
            hasVariant(globalVariants, "mobile", "mobile")
              ? false
              : hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? false
                : true
          ) ? (
            <HomeLoginSection
              data-plasmic-name={"homeLoginSection"}
              data-plasmic-override={overrides.homeLoginSection}
              className={classNames("__wab_instance", sty.homeLoginSection)}
            />
          ) : null}
          <HomeTopSection
            data-plasmic-name={"homeTopSection"}
            data-plasmic-override={overrides.homeTopSection}
            className={classNames("__wab_instance", sty.homeTopSection)}
            onContactClick={async () => {
              const $steps = {};

              $steps["updateContactModalOpen"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["contactModal", "open"]
                      },
                      operation: 0,
                      value: true
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateContactModalOpen"] != null &&
                typeof $steps["updateContactModalOpen"] === "object" &&
                typeof $steps["updateContactModalOpen"].then === "function"
              ) {
                $steps["updateContactModalOpen"] =
                  await $steps["updateContactModalOpen"];
              }
            }}
          />

          <HomeSolutionsSection
            data-plasmic-name={"homeSolutionsSection"}
            data-plasmic-override={overrides.homeSolutionsSection}
            className={classNames("__wab_instance", sty.homeSolutionsSection)}
          />

          <HomeProductsSection
            data-plasmic-name={"homeProductsSection"}
            data-plasmic-override={overrides.homeProductsSection}
            className={classNames("__wab_instance", sty.homeProductsSection)}
          />

          <HomeCaseStudiesSection
            data-plasmic-name={"homeCaseStudiesSection"}
            data-plasmic-override={overrides.homeCaseStudiesSection}
            className={classNames("__wab_instance", sty.homeCaseStudiesSection)}
          />

          <HomeBenefitsSection
            data-plasmic-name={"homeBenefitsSection"}
            data-plasmic-override={overrides.homeBenefitsSection}
            className={classNames("__wab_instance", sty.homeBenefitsSection)}
          />

          <CalloutSection
            data-plasmic-name={"calloutSection"}
            data-plasmic-override={overrides.calloutSection}
            className={classNames("__wab_instance", sty.calloutSection)}
            onContactClick={async () => {
              const $steps = {};

              $steps["updateContactModalOpen"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["contactModal", "open"]
                      },
                      operation: 0,
                      value: true
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateContactModalOpen"] != null &&
                typeof $steps["updateContactModalOpen"] === "object" &&
                typeof $steps["updateContactModalOpen"].then === "function"
              ) {
                $steps["updateContactModalOpen"] =
                  await $steps["updateContactModalOpen"];
              }
            }}
          />

          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
            onContactClick={async () => {
              const $steps = {};

              $steps["updateContactModalOpen"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["contactModal", "open"]
                      },
                      operation: 0,
                      value: true
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateContactModalOpen"] != null &&
                typeof $steps["updateContactModalOpen"] === "object" &&
                typeof $steps["updateContactModalOpen"].then === "function"
              ) {
                $steps["updateContactModalOpen"] =
                  await $steps["updateContactModalOpen"];
              }
            }}
          />

          <ContactModal
            data-plasmic-name={"contactModal"}
            data-plasmic-override={overrides.contactModal}
            className={classNames("__wab_instance", sty.contactModal)}
            onOpenChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, ["contactModal", "open"]).apply(
                null,
                eventArgs
              );

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            open={generateStateValueProp($state, ["contactModal", "open"])}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "header",
    "serviceMessage",
    "homeLoginSection",
    "homeTopSection",
    "homeSolutionsSection",
    "homeProductsSection",
    "homeCaseStudiesSection",
    "homeBenefitsSection",
    "calloutSection",
    "footer",
    "contactModal"
  ],
  header: ["header"],
  serviceMessage: ["serviceMessage"],
  homeLoginSection: ["homeLoginSection"],
  homeTopSection: ["homeTopSection"],
  homeSolutionsSection: ["homeSolutionsSection"],
  homeProductsSection: ["homeProductsSection"],
  homeCaseStudiesSection: ["homeCaseStudiesSection"],
  homeBenefitsSection: ["homeBenefitsSection"],
  calloutSection: ["calloutSection"],
  footer: ["footer"],
  contactModal: ["contactModal"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  header: typeof Header;
  serviceMessage: typeof ServiceMessage;
  homeLoginSection: typeof HomeLoginSection;
  homeTopSection: typeof HomeTopSection;
  homeSolutionsSection: typeof HomeSolutionsSection;
  homeProductsSection: typeof HomeProductsSection;
  homeCaseStudiesSection: typeof HomeCaseStudiesSection;
  homeBenefitsSection: typeof HomeBenefitsSection;
  calloutSection: typeof CalloutSection;
  footer: typeof Footer;
  contactModal: typeof ContactModal;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHome__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHome__VariantsArgs;
    args?: PlasmicHome__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHome__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHome__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHome__ArgProps,
          internalVariantPropNames: PlasmicHome__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHome__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHome";
  } else {
    func.displayName = `PlasmicHome.${nodeName}`;
  }
  return func;
}

export const PlasmicHome = Object.assign(
  // Top-level PlasmicHome renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    serviceMessage: makeNodeComponent("serviceMessage"),
    homeLoginSection: makeNodeComponent("homeLoginSection"),
    homeTopSection: makeNodeComponent("homeTopSection"),
    homeSolutionsSection: makeNodeComponent("homeSolutionsSection"),
    homeProductsSection: makeNodeComponent("homeProductsSection"),
    homeCaseStudiesSection: makeNodeComponent("homeCaseStudiesSection"),
    homeBenefitsSection: makeNodeComponent("homeBenefitsSection"),
    calloutSection: makeNodeComponent("calloutSection"),
    footer: makeNodeComponent("footer"),
    contactModal: makeNodeComponent("contactModal"),

    // Metadata about props expected for PlasmicHome
    internalVariantProps: PlasmicHome__VariantProps,
    internalArgProps: PlasmicHome__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/",
      pagePath: "/",
      params: {},
      query: {}
    })
  }
);

export default PlasmicHome;
/* prettier-ignore-end */
